import useCheckboxPreset from "~/components/abstracts/Checkbox/hooks/useCheckboxPreset"

export { useCheckboxPreset }
